module.exports = __webpack_public_path__ + "static/media/menu.2cfb4913.svg";